export const setSessionInfo = (session) => ({
    session,
    type: 'STORE_INFO'
});

export const setTenant = (tenantId, tenantData) => ({
    tenantData,
    tenantId,
    type: 'SET_TENANT'
});

export const setTenantError = (tenantId) => ({
    tenantId,
    type: 'SET_TENANT_ERROR'
});

export const setTenantIsStale = (tenantId) => ({
    tenantId,
    type: 'TENANT_IS_STALE'
});
